import React from 'react';
import { IProceedingsSearchResult } from 'typings/proceedings';
import { Text } from '@morressier/ts';
import { ProceedingsCard } from './styles';

const ProceedingsCardWrapper: React.FC<IProceedingsSearchResult> = ({
  id,
  paperAuthors,
  paperKeywords,
  journalName,
  paperName,
  paperTopics,
  conferenceName,
  conferenceOrganization,
  publisherName
}) => {
  return (
    <ProceedingsCard key={id}>
      <Text>
        published by <em style={{ fontWeight: 700 }}>{publisherName}</em> in{' '}
        <em style={{ fontWeight: 700 }}>{journalName}</em>
      </Text>
      <Text
        style={{
          fontWeight: 700,
          fontSize: '1.25rem',
          margin: '0.5rem 0 0.5rem 0',
          lineHeight: '1.75rem'
        }}
      >
        {paperName}
      </Text>
      <Text>Authors: {paperAuthors}</Text>
      <Text>Conference Name: {conferenceName}</Text>
      <Text>Conference Organization: {conferenceOrganization}</Text>
      <Text>Paper Topics: {paperTopics}</Text>
      <Text>Paper Keywords: {paperKeywords}</Text>
    </ProceedingsCard>
  );
};

export default ProceedingsCardWrapper;
